import { formatPrice } from "./common";

export const subscriptions = {
  formatPrice,
};
